import { useTranslation } from "react-i18next";
import Select from "../../../../components/Select";
import "./SalarialConditionPreview.scss";

export default function CurrentLocation({currentLocation}){

    let {t} = useTranslation();
    const { i18n } = useTranslation();

    function citySalaryLocationPosition() {
        if(i18n.language === "PT"){
            return "margin-pt";
        }else if (i18n.language === "EN"){
            return "margin-en";
        }else if(i18n.language === "FR"){
            return "margin-fr";
        }else if(i18n.language === "ES"){
            return "margin-es";
        }
    }

  return ( 
    <div className="row"> 
        <div className="col-md-6">
            <div className="form-group">
                <div className="label-wrapper">
                    {window.location.pathname.includes("createOrEdit") === true ? (
                        <label htmlFor="personalDetailLabelZone">{t("Country")}</label>
                    ) : (
                        <legend className="fontsize-legend">{t("Country")}</legend>
                    )}
                </div>
                <Select
                    id="countryId"
                    name="CountryId"
                    value={currentLocation.country ||""}
                    disabled={true}
                    className="form-select"
                    style={{width: "275px"}}
                >
                    {currentLocation.country ? (
                    <option>
                        {currentLocation.country}
                    </option>
                ) : (
                    <option></option>
                )}
                </Select>
            </div>
        </div>
        <div className="col-md-6">
            <div className={`form-group ${citySalaryLocationPosition(i18n.language)}`}>
                <div className="label-wrapper">
                    {window.location.pathname.includes("createOrEdit") === true ? (
                    <label htmlFor="cities">{t("City")}</label>
                    ) : (
                    <legend className="fontsize-legend">{t("City")}</legend>
                    )}
                </div>
                <Select
                    disabled={true}
                    id="cityId"
                    name="cityId"
                    className="form-select"
                    value={currentLocation.city || ""}
                >
                    {currentLocation.city ? (
                        <option>
                            {currentLocation.city}
                        </option>
                    ) : (
                        <option></option>
                    )}
                </Select>
            </div>
        </div>
    </div>
  );
}